import script from "./FrmExpeditionNewNoSalesOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./FrmExpeditionNewNoSalesOrder.vue?vue&type=script&setup=true&lang=js"

import "./FrmExpeditionNewNoSalesOrder.vue?vue&type=style&index=0&id=02a332f3&lang=scss"

const __exports__ = script;

export default __exports__